import { isWeixin } from 'jyutils/utils';
export default {
  data () {
    return {
      w: 0,
      upload4Web: 'sys/utils/upload4Web',
    }
  },
  computed: {
    member() {
      return this.$store.getters.member;
    },
    isWeixin() {
      return isWeixin();
    },
  },
  activated() {
    if (!this.w) {
      this.getImgW();
    }
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });
  },
  mounted () {
    this.getImgW();
  },
  methods: {
    getImgW() {
      this.$nextTick(() => {
        this.w = this.$refs.body && this.$refs.body.offsetWidth;
      });
    },
    goBack(route) {
      if (!route) {
        this.$router.back();
      } else {
        this.$router.push(route);
      }
    },
    login(backRoute) {
      // 如果是微信浏览器，记住登录后返回路由
      this.doLogin(backRoute || this.$route);
    },
    // 检查登录
    checkLogin() {
      if (!this.member.id || (this.isWeixin && !this.member.openid)) {
        // console.log(this.member)
        setTimeout(() => {
          this.login(this.$route);
        }, 100);
      }
    },
    rollStatusColor(status) {
      if (status == 'ZD') {
        return '#1989fa';
      } else if (status == 'BM') {
        return '#07c160';
      } else if (status == 'JF') {
        return '#ee0a24';
      } else if (status == 'DJ') {
        return '#7232dd';
      }
    },
    webPrice(price, showzero = true) {
      let value = null;
      if (showzero) {
        value = (price ? price / 100 : 0).toFixed(2);
      }
      value = (price ? (price / 100).toFixed(2) : null);
      if (value) {
        value = value.split('.');
        return `<span class="price-001">${value[0]}</span><small class="price-002">.${value[1]}</small>`
      }
      return value;
    },
  }
}